<div
  class="legend"
  i18n="Heading OPLC|Heading in login dialog@@OutriggerPadLoadCalculator"
>
  Outrigger Pad Load Calculator
</div>
<div
  style="margin-top: 21px"
  *ngIf="
    appStatus['loginStatus'] == 'loggedOff' ||
    appStatus['loginStatus'] == 'notLoggedIn'
  "
>
  <ng-container
    i18n="Enter email adress|Text enter email adress@@EnterEmailadress"
    >Please enter your email address</ng-container
  >.<br />
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" id="loginForm">
    <span formGroupName="loginData">
      <div style="margin-top: 21px">
        <div class="FeldBeschreibung">
          <ng-container
            i18n="Email adress|Label for email adress input field@@EmailAdress"
            >eMail Address</ng-container
          >:
        </div>
        <input
          #eMail
          class="EingabeFeld"
          type="text"
          formControlName="email"
          [(ngModel)]="email"
          (change)="speichere('email', eMail.value)"
        /><span
          *ngIf="loginForm.hasError('invalidEmail', 'email') && submitPressed"
          ><ng-container
            i18n="
              Enter correct email adress|text Enter correct email
              adress@@CorrectEmailAdress"
          >
            Please give a correct e-mail address</ng-container
          >.</span
        >
      </div>
      <div>
        <div class="FeldBeschreibung">
          <ng-container
            i18n="
              Label confirmation|Label confirmation in login
              screen@@Confirmation"
            >Confirmation</ng-container
          >:
        </div>
        <input
          #confirmationEMail
          class="EingabeFeld"
          type="text"
          [(ngModel)]="confirmation"
          formControlName="confirmation"
          (change)="speichere('confirmation', confirmationEMail.value)"
        />
      </div>
    </span>
    <jw-modal id="disclaimerBox">
      <h1>
        <ng-container
          i18n="
            HeaderDisclaimer|Header of Disclaimer on login
            page@@DisclaimerHeader"
          >Disclaimer</ng-container
        >
      </h1>
      <ng-container
        i18n="Disclaimertext|text of Disclaimer on login page@@DisclaimerText"
      >
        <p>
          The Outrigger Pad Load calculations produced by this software are not
          a substitute for adherence to all load chart requirements and safe
          crane operating practices and limitations. Always confirm that the
          lifted load and the actual crane configuration are approved by the
          applicable load chart. In addition, the accuracy of the Outrigger Pad
          Load calculations is entirely dependent upon the user inputting proper
          data/information. If inaccurate data is input, the Outrigger Pad Load
          calculations will not be accurate.
        </p>
        <p>
          Design of ground support sufficient to withstand calculated loads is
          within the sole responsibility of the user of this software and/or the
          Site Supervisor (see ASME B30.5-2007 5-3.1.3.2.1(e)(3)). Reliance upon
          inaccurate calculations and/or improper ground support could lead to
          tip over (and potentially result in death, serious bodily injury,
          damage to the crane and/or damage to other property). If you have any
          questions as to whether the data/information you are inputting into
          the software is accurate, please contact Product Marketing.
        </p>
      </ng-container>
      <button (click)="closeModal('disclaimerBox')">
        <ng-container
          i18n="
            disclaimerBoxCloseButton|Text for close button of disclaimer
            box|CloseDisclaimerModalBox
          "
          >Close</ng-container
        >
      </button>
    </jw-modal>
    <div>
      <div class="FeldBeschreibung" style="text-align: right">
        <input
          #disclaimerCheckbox
          id="disclaimerAcceptedCheckbox"
          type="checkbox"
          [(ngModel)]="disclaimerAccepted"
          (click)="disclaimerAcceptedClicked()"
          formControlName="disclaimerAccepted"
        />&nbsp;
      </div>
      <span class="EingabeFeld">
        <label for="disclaimerAcceptedCheckbox"
          ><ng-container
            i18n="
              Label Disclaimer accepted|Label disclaimer accepted in login
              screen@@AcceptDisclaimer"
            >Accept
            <a id="DisclaimerLabelLink" (click)="openModal('disclaimerBox')"
              >disclaimer</a
            ></ng-container
          ></label
        >
      </span>
    </div>
    <span *ngIf="loginForm.hasError('equal') && submitPressed"
      ><ng-container
        i18n="
          Email and confirmation error|Given email adress and confirmation do
          not match@@EmailConfirmationError"
        >Email address and confirmation must be the same</ng-container
      >.</span
    ><br />
    <span *ngIf="submitPressed && loginForm.get('disclaimerAccepted').invalid">
      <ng-container
        i18n="
          Disclaimer not accepted Error|Error if disclaimer is not accepted on
          login page@@DisclaimerNotAccepted"
      >
        You need to accept the disclaimer to proceed.
      </ng-container>
      <br />
    </span>
    <div
      *ngIf="
        submitPressed &&
        !loginForm.get('disclaimerAccepted').invalid &&
        appStatus['loginStatus'] != 'loggedIn'
      "
      i18n="
        Login error message|An error occured while logging in@@LoginErrorMessage"
    >
      A problem occured while logging in. Please try again. <br />Maybe just
      waiting for answer.
    </div>
    <a class="css-button">
			<span class="css-button-text" form="loginForm" (click)="onSubmit()"><ng-container i18n="Login label|Label for login@@Login">Login</ng-container></span>
		</a>
  </form>
</div>
<span *ngIf="appStatus['loginStatus'] == 'loggedIn'"
  ><ng-container i18n="Logged in as|Message if already logged in@@LoggedInAs"
    >You are already logged in as</ng-container
  >
  "{{ appStatus["EMail"] }}".<br />
      <a class="css-button">
    <span class="css-button-text" form="loginForm" (click)="logOff()"><ng-container i18n="button logout|Label for logout button@@Logout">Logout</ng-container></span>
  </a>
</span>
